import type { RouteObject } from "react-router-dom";
import { LoginAuthCommonScreen } from "../screens/common/auth/login-auth.common.screen";
import { NotFound } from "../components/not-found.components";
import { CreateBrandCommonScreen } from "../screens/common/auth/create-brand.common.screen";
import { PhoneVerifyCommonScreen } from "../screens/common/auth/phone-verify.common.screen";

export const authRouter: Array<RouteObject> = [
	{
		path: "login",
		element: <LoginAuthCommonScreen />,
	},
	{
		path: "onboarding",
		element: <CreateBrandCommonScreen />,
	},
	{
		path: "phone",
		element: <PhoneVerifyCommonScreen/>
	},
	{
		path: "*",
		element: <NotFound />,
	},
];
